import { render } from "./NurseList.vue?vue&type=template&id=3ab98ec0"
import script from "./NurseList.vue?vue&type=script&lang=js"
export * from "./NurseList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__